module.exports = __webpack_public_path__ + "img/chatgpt.82f3420c.png";